import { persistReducer } from './persist-reducer.util'

export const usePersistReducer = persistReducer()
